import React, {Component} from 'react';
import { IoInformationCircleOutline } from "react-icons/io5";

const TIME_TO_FIRST_INFO_SECS = 60 * 15; // 15 minutes

class FullTestTimer extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      elapsed: this.getElapsedSeconds()
    };
    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    if (this.state.elapsed < this.props.durationSec) {
      this.timer = setInterval(this.tick, 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  tick() {
    let elapsed = this.getElapsedSeconds();

    if(elapsed === TIME_TO_FIRST_INFO_SECS) {
      this.props.onInfo();
    }

    if (elapsed > this.props.durationSec) {
      this.props.onComplete();
      elapsed = this.props.durationSec;
      clearInterval(this.timer);
    }
    this.setState({elapsed});
  }

  getElapsedSeconds() {
    return Math.round((Date.now() - this.props.start) / 1000);
  }

  render() {
    const secondsLeft = Math.max(this.props.durationSec - this.state.elapsed, 0);
    const minutes = Math.floor(secondsLeft / 60);
    let seconds = secondsLeft - minutes * 60;
    seconds = ("0" + seconds).slice(-2);
    return (
        <div id="full-test-timer-container"
          className="timer vertical-middle body-container-wrapper touchable" onClick={this.props.onClick} ref={this.props.innerRef}>
          {minutes + ':' + seconds}
          {this.props.showInfoIcon && (
            <IoInformationCircleOutline size={22} className="tiny-left-margin" />
          )}
        </div>
    )
  }
}

export default FullTestTimer;
